<template>
    <br/>
    <span class="text-muted">
        <span>{{ translate('labels.balance') }}: <span :class="{'text-danger': option.balance_with_reserve < 0}">{{ option.balance_with_reserve }}</span> | </span>
        <span>{{ translate('labels.reserve') }}: <span :class="{'text-danger': option.reserve < 0}">{{ option.reserve }}</span> | </span>
        <span>{{ translate('labels.waiting') }}: <span :class="{'text-danger': option.waiting < 0}">{{ option.waiting }}</span> | </span>
        <span>{{ translate('labels.lack') }}: <span :class="{'text-danger': option.lack < 0}">{{ option.lack < 0 ? option.lack : 0 }}</span> </span>
    </span>
</template>
<script>
export default {
    name: "ProductAvailabilitySelectOption",
    props: {
        option: {
            type: Object,
            required: true
        }
    }
}
</script>
<style>
li[aria-selected=true] > span.text-muted {
    color: #fff !important
}
</style>